import { SampleShipmentRequests } from '@etoh/database/core';

export function getSamplesShipmentRequestsToSend(
  sampleShipmentRequests: SampleShipmentRequests[],
  itemId: number
): SampleShipmentRequests[] {
  return sampleShipmentRequests.filter(
    (s) =>
      s.itemId === itemId &&
      !s.archivedAt &&
      !s.deletedAt &&
      !s.sampleShipmentId
  );
}
